import { Component, Input } from '@angular/core';
import { EditWidgetComponent } from '../edit-widget.component';

@Component({
  selector: 'app-edit-widget-store-panel',
  templateUrl: './edit-widget-store-panel.component.html',
  styleUrls: ['./edit-widget-store-panel.component.scss']
})
export class EditWidgetStorePanelComponent {
  @Input() ctrl!: EditWidgetComponent;
}
